// Imports
import React from "react";
import { Route, Switch } from "react-router-dom";
// import AdminLayout from './../layouts/Admin'
import { routes } from "../setup/routes";
import LoginForm from "../components/Login/LoginForm";
import SchedulingLayout from "../layouts/SchedulingLayout/SchedulingLayout";
import PasswordForgot from "../components/Login/EmailForgotPassword.jsx";
import ResetPassword from "../components/Login/ForgotPassword.jsx";
import ReporteVacaciones from "../components/Views/ReporteVacaciones.jsx";
import headcount from "../components/Login/headcount.jsx";
import genera_planilla_produccion from "../components/Login/genera_planilla_produccion.jsx";

const App = () => (
  <div>
    <Switch>
      <Route path={routes.home} component={LoginForm} exact />
      <Route path={routes.passwordForgot} component={PasswordForgot} exact />
      <Route path={routes.resetPassword} component={ResetPassword} exact />
      <Route path={routes.ReporteVacaciones} component={ReporteVacaciones} exact />
      <Route path={routes.headcount} component={headcount} exact />
      <Route path={routes.genera_planilla_produccion} component={genera_planilla_produccion} exact />
      

      {/* <Route path={routes.admin} render={props => <AdminLayout {...props} />} /> */}
      <Route path={routes.about} component={SchedulingLayout} />
    </Switch>
  </div>
  /*
         <div>
            <Switch>
                <Route path={routes.home} render={props => <AdminLayout {...props} />}  />
            </Switch>
        </div> */
);
export default App;
